import React from 'react'

import Patient from 'presentation/doctor/pages/Patient'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { ApiClientImplementation } from 'infra/api-client/api-client'
import { ApiRepository } from 'repository/api-repository'
import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'
import { RemoteAddFavorite } from 'service/usecases/add-favorite/remote-add-favorite'
import { RemoteLoadSurgicalOrder } from 'service/usecases/load-surgical-order/remote-load-surgical-order'

export default function makeDoctorAddSurgicalOrderInfo() {
  const apiClient = new ApiClientImplementation()
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(apiClient)
  )

  const surgicalOrderRepository = new SurgicalOrderRepository(apiRepository)

  const loadSurgicalOrder = new RemoteLoadSurgicalOrder(surgicalOrderRepository)
  const addFavorite = new RemoteAddFavorite(surgicalOrderRepository)

  return (
    <Patient loadSurgicalOrder={loadSurgicalOrder} addFavorite={addFavorite} />
  )
}
